var _excluded = ["name"],
  _excluded2 = ["label"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MediaContext } from 'react-media-query-hoc';
import { ListingSearchAutocomplete } from '@domain-group/fe-co-allhomes-autocomplete';
import * as styles from './search-location.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SearchLocation = _ref => {
  var filters = _ref.filters,
    onSearch = _ref.onSearch,
    onLocationEntryClick = _ref.onLocationEntryClick,
    propertyAlertButton = _ref.propertyAlertButton,
    mobilePropertyAlertButton = _ref.mobilePropertyAlertButton;
  var _useContext = useContext(MediaContext),
    mobile = _useContext.mobile;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    pending = _useState2[0],
    setPending = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isActive = _useState4[0],
    setIsActive = _useState4[1];
  useEffect(() => {
    // reset the pending state if the user hits "back"
    var resetPending = () => setPending(false);
    window.addEventListener('pageshow', resetPending);
    return () => window.removeEventListener('pageshow', resetPending);
  }, []);
  var handleSearch = values => {
    var localities = values && values.map(_ref2 => {
      var name = _ref2.name,
        rest = _objectWithoutProperties(_ref2, _excluded);
      return _objectSpread({
        label: name
      }, rest);
    });
    onSearch(filters.cloneWithLocalities(localities));
  };
  var handleImmediateSearch = value => {
    if (value.url) {
      setPending(true);
      window.location = value.url;
    }
    handleSearch([value]);
  };
  var handleSelectionChange = values => {
    if (!mobile) {
      handleSearch(values);
    }
  };
  var values = filters.getBounds() ? [{
    name: 'Map Area'
  }] : (filters.getLocalities() || []).map(_ref3 => {
    var label = _ref3.label,
      rest = _objectWithoutProperties(_ref3, _excluded2);
    return _objectSpread(_objectSpread({}, rest), {}, {
      name: label,
      label
    });
  });
  var autocompleteKey = JSON.stringify(values);
  return ___EmotionJSX("div", {
    css: styles.searchLocation
  }, ___EmotionJSX("div", {
    css: styles.autocompleteContainer(isActive)
  }, ___EmotionJSX(ListingSearchAutocomplete, {
    css: styles.autocomplete,
    key: autocompleteKey,
    pending: pending,
    listingtype: filters.listingType,
    inputType: "form",
    initialSelectedItems: values,
    onSelectionChange: handleSelectionChange,
    onImmediateSearch: handleImmediateSearch,
    onSearch: handleSearch,
    onEntryClick: onLocationEntryClick,
    onDropdownOpen: setIsActive,
    noBorder: true,
    extensions: {
      modalPlaceholder: mobilePropertyAlertButton
    }
  })), !mobile && propertyAlertButton);
};
SearchLocation.propTypes = {
  filters: PropTypes.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  onSearch: PropTypes.func,
  onLocationEntryClick: PropTypes.func,
  propertyAlertButton: PropTypes.node,
  mobilePropertyAlertButton: PropTypes.node
};
SearchLocation.defaultProps = {
  onSearch: () => {},
  onLocationEntryClick: () => {},
  propertyAlertButton: undefined,
  mobilePropertyAlertButton: undefined
};
export default SearchLocation;